<template>
  <div class="achievement-section d2p-section">
    <div class="main-container">
      <div class="title-container">
        <h2>{{ t("home.products.title") }}</h2>
      </div>

      <div class="subtitle">
        <p>{{ t("home.products.subtitle1") }}</p>
      </div>

      <div class="cards-container d2p-container"> 
        <div class="card card-1" :class="{ active: activeCard === 1 }" @mouseenter="handleCardHover(1)">
          <div class="card-background">
            <img src="../../assets/image/home/home_d2p_d2p_n2.png" :alt="$t('home.products.card1Alt')" class="bg-image small-img" />
            <img src="../../assets/image/home/home_d2p_pf.png" :alt="$t('home.products.card1Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3 style="margin-bottom: 0;">{{ $t("home.products.card1Title") }}</h3>
              <h4>{{ $t("home.products.card1TitleEn") }}</h4>
            </div>
          </div>
        </div>

        <div class="card card-2" :class="{ active: activeCard === 2 }" @mouseenter="handleCardHover(2)">
          <div class="card-background">
           <img src="../../assets/image/home/home_d2p_cfi_nomal.png" :alt="$t('home.product.card2Alt')" class="bg-image small-img" /> 
            <img src="../../assets/image/home/home_d2p_cfi .png" :alt="$t('home.product.card2Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.products.card2Title") }}</h3>
              <h4>{{ $t("home.products.card2TitleEn") }}</h4>
            </div>
          </div>
        </div>

        <div class="card card-3" :class="{ active: activeCard === 3 }" @mouseenter="handleCardHover(3)">
          <div class="card-background">
            <img src="../../assets/image/home/home_d2p_al.png" :alt="$t('product.card3Alt')" class="bg-image small-img" />
            <img src="../../assets/image/home/home_d2p_al.png" :alt="$t('product.card3Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.products.card3Title") }}</h3>
              <h4>{{ $t("home.products.card3TitleEn") }}</h4>
            </div>
          </div>
        </div>

        <div class="card card-4" :class="{ active: activeCard === 4 }" @mouseenter="handleCardHover(4)">
          <div class="card-background">
            <img src="../../assets/image/home/home_d2p_d2pi.png" :alt="$t('home.product.card4Alt')" class="bg-image small-img" />
            <img src="../../assets/image/home/home_d2p_d2pi.png" :alt="$t('home.product.card4Alt')" class="bg-image large-img" />
          </div>
          <div class="card-content">
            <div class="text-content">
              <h3>{{ $t("home.products.card4Title") }}</h3>
              <h4>{{ $t("home.products.card4TitleEn") }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { locale, t } = useI18n();
const activeCard = ref(1);

const handleCardHover = (cardId) => {
  activeCard.value = cardId;
};

onMounted(() => {
  activeCard.value = 1;
});
</script>

<style scoped>
  @import "@/assets/css/product.css";
</style>